import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export default class RoundUpUtil {
  roundUpAmount(num: number, decimalPlaces: number) {
    const factor = Math.pow(10, decimalPlaces);
    const result = (Math.ceil(num * factor) / factor).toFixed(decimalPlaces);
    return result;
  }
}
